import { AdminApi } from 'stylemix-vue-admin'

export default class OrdersApi extends AdminApi {
  constructor(parameters) {
    super('orders', parameters)
  }

  all(config = {}) {
    return this.submit('get', `/${this.endpoint}/my`, null, config)
  }
}
